import { render, staticRenderFns } from "./Legislation.vue?vue&type=template&id=42f7a24e&scoped=true"
import script from "./Legislation.vue?vue&type=script&lang=js"
export * from "./Legislation.vue?vue&type=script&lang=js"
import style0 from "./Legislation.vue?vue&type=style&index=0&id=42f7a24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f7a24e",
  null
  
)

export default component.exports